import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import Footer from "@/components/Footer";
import MartinLewisQuote from "@/components/MartinLewisQuote";

const Index = () => {
  return (
    <div className="flex flex-col items-start w-full min-h-screen bg-white font-inter">
      <section 
        className="w-full min-h-[500px] md:h-[700px] relative overflow-hidden bg-cover bg-center px-4 md:px-0"
        style={{
          backgroundImage: "url('/lovable-uploads/b4534dc1-7248-4c88-b190-08012401c9cf.png')",
        }}
      >
        <div className="container mx-auto pt-24 md:pt-32">
          <div className="max-w-[806px] bg-white/30 backdrop-blur-[40px] rounded-xl p-4 md:p-8">
            <div className="max-w-[674px] space-y-6 md:space-y-8">
              <h1 className="text-3xl md:text-5xl font-bold text-[#111827] leading-tight">
                Save up to £950 per year with our free Energy Report
              </h1>
              <p className="text-lg md:text-xl text-[#4B5563]">
                Let AI analyse your energy consumption and discover how to reduce your bills with personalised DIY recommendations.
              </p>
              <Button 
                className="w-full md:w-auto h-[50px] md:h-[60px] px-6 md:px-8 text-base md:text-lg bg-[#059669] hover:bg-[#059669]/90 shadow-lg"
                asChild
              >
                <Link to="/auth">Get your free energy report</Link>
              </Button>
            </div>
          </div>
        </div>
      </section>

      <section className="w-full bg-white py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <div style={{position: 'relative', width: '100%', height: '0px', paddingBottom: '56.250%'}}>
              <iframe 
                allow="fullscreen" 
                allowFullScreen 
                height="100%" 
                src="https://streamable.com/e/n6sqka?" 
                width="100%" 
                style={{
                  border: 'none',
                  width: '100%',
                  height: '100%',
                  position: 'absolute',
                  left: '0px',
                  top: '0px',
                  overflow: 'hidden'
                }}
              />
            </div>
          </div>
        </div>
      </section>

      <section className="w-full py-20">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center text-[#1F2937] mb-16">
            How It Works
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white p-8 rounded-xl shadow-lg">
              <div className="w-16 h-16 bg-[#D1FAE5] rounded-full flex items-center justify-center mb-8">
                <svg className="w-6 h-6 text-[#059669]" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M10 12a2 2 0 100-4 2 2 0 000 4z"/>
                  <path fillRule="evenodd" d="M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z" clipRule="evenodd"/>
                </svg>
              </div>
              <h3 className="text-xl font-bold text-[#1F2937] mb-4">Share your information</h3>
              <p className="text-[#4B5563]">
                Upload your energy bills and provide basic details about your consumption patterns.
              </p>
            </div>

            <div className="bg-white p-8 rounded-xl shadow-lg">
              <div className="w-16 h-16 bg-[#D1FAE5] rounded-full flex items-center justify-center mb-8">
                <svg className="w-6 h-6 text-[#059669]" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M11.3 1.046A1 1 0 0112 2v5h4a1 1 0 100-2H9z"/>
                  <path fillRule="evenodd" d="M4 5a2 2 0 012-2 3 3 0 003 3h2a3 3 0 003-3 2 2 0 012 2v11a2 2 0 01-2 2H6a2 2 0 01-2-2V5zm3 4a1 1 0 000 2h.01a1 1 0 100-2H7zm3 0a1 1 0 000 2h3a1 1 0 100-2h-3zm-3 4a1 1 0 100 2h.01a1 1 0 100-2H7zm3 0a1 1 0 100 2h3a1 1 0 100-2h-3z" clipRule="evenodd"/>
                </svg>
              </div>
              <h3 className="text-xl font-bold text-[#1F2937] mb-4">AI Analysis</h3>
              <p className="text-[#4B5563]">
                Our AI processes your data in combination with your publicly available EPC records and our proprietary data models.
              </p>
            </div>

            <div className="bg-white p-8 rounded-xl shadow-lg">
              <div className="w-16 h-16 bg-[#D1FAE5] rounded-full flex items-center justify-center mb-8">
                <svg className="w-6 h-6 text-[#059669]" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M9 2a1 1 0 000 2h2a1 1 0 100-2H9z"/>
                  <path fillRule="evenodd" d="M4 5a2 2 0 012-2 3 3 0 003 3h2a3 3 0 003-3 2 2 0 012 2v11a2 2 0 01-2 2H6a2 2 0 01-2-2V5zm3 4a1 1 0 100 2h.01a1 1 0 100-2H7zm3 0a1 1 0 000 2h3a1 1 0 100-2h-3zm-3 4a1 1 0 100 2h.01a1 1 0 100-2H7zm3 0a1 1 0 100 2h3a1 1 0 100-2h-3z" clipRule="evenodd"/>
                </svg>
              </div>
              <h3 className="text-xl font-bold text-[#1F2937] mb-4">Get your report</h3>
              <p className="text-[#4B5563]">
                We combine your data with our AI to provide an energy assessment that is specific to your situation.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="w-full bg-[#F9FAFB] py-20">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
            <div className="space-y-8">
              <h2 className="text-3xl font-bold text-[#1F2937]">
                Why Choose KOSI
              </h2>
              
              <div className="space-y-6">
                <div className="flex gap-4">
                  <div className="w-12 h-12 bg-[#D1FAE5] rounded-lg flex items-center justify-center flex-shrink-0">
                    <svg className="w-4 h-4 text-[#059669]" fill="currentColor" viewBox="0 0 16 16">
                      <path d="M8 0a8 8 0 100 16A8 8 0 008 0zm3.57 6.51l-4.97 4.97a.75.75 0 01-1.06 0L3.44 9.38a.75.75 0 011.06-1.06l1.57 1.57 4.44-4.44a.75.75 0 011.06 1.06z"/>
                    </svg>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-[#1F2937]">
                      Get answers without hours of online research
                    </h3>
                    <p className="text-[#4B5563] mt-2">
                      Let our AI do the heavy lifting and give you the right suggestions.
                    </p>
                  </div>
                </div>

                <div className="flex gap-4">
                  <div className="w-12 h-12 bg-[#D1FAE5] rounded-lg flex items-center justify-center flex-shrink-0">
                    <svg className="w-4 h-4 text-[#059669]" fill="currentColor" viewBox="0 0 16 16">
                      <path fillRule="evenodd" d="M11.3 1.046A1 1 0 0112 2v5h4a1 1 0 100-2H9z"/>
                      <path fillRule="evenodd" d="M4 5a2 2 0 012-2 3 3 0 003 3h2a3 3 0 003-3 2 2 0 012 2v11a2 2 0 01-2 2H6a2 2 0 01-2-2V5zm3 4a1 1 0 000 2h.01a1 1 0 100-2H7zm3 0a1 1 0 000 2h3a1 1 0 100-2h-3zm-3 4a1 1 0 100 2h.01a1 1 0 100-2H7zm3 0a1 1 0 100 2h3a1 1 0 100-2h-3z" clipRule="evenodd"/>
                    </svg>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-[#1F2937]">
                      It's free
                    </h3>
                    <p className="text-[#4B5563] mt-2">
                      Currently we offer our service free of charge.
                    </p>
                  </div>
                </div>

                <div className="flex gap-4">
                  <div className="w-12 h-12 bg-[#D1FAE5] rounded-lg flex items-center justify-center flex-shrink-0">
                    <svg className="w-4 h-4 text-[#059669]" fill="currentColor" viewBox="0 0 16 16">
                      <path d="M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27.68 0 1.36.09 2 .27 1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.013 8.013 0 0016 8c0-4.42-3.58-8-8-8z"/>
                    </svg>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-[#1F2937]">
                      Unbiased Recommendations
                    </h3>
                    <p className="text-[#4B5563] mt-2">
                      Get transparent, data-driven suggestions without a hidden agenda.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div>
              <h2 className="text-3xl font-bold text-[#1F2937] mb-8">
                What Our Users Say
              </h2>
              
              <div className="space-y-8">
                <div className="bg-white rounded-xl shadow-lg p-6">
                  <div className="flex items-center gap-4 mb-6">
                    <img 
                      src="/lovable-uploads/cd532dd5-b32f-482c-8a5c-b9784a852464.png"
                      alt="Sarah Johnson" 
                      className="w-12 h-12 rounded-full object-cover"
                    />
                    <div>
                      <h3 className="font-bold text-[#1F2937]">Sarah Johnson</h3>
                      <p className="text-[#6B7280]">London</p>
                    </div>
                  </div>
                  <p className="text-[#4B5563]">
                    "KOSI helped me reduce my energy bills by 30%. The recommendations were practical and easy to implement."
                  </p>
                </div>

                <div className="bg-white rounded-xl shadow-lg p-6">
                  <div className="flex items-center gap-4 mb-6">
                    <img 
                      src="/lovable-uploads/81dd3555-31ac-4b3c-bb53-2381ff7c940e.png"
                      alt="Mark Thompson" 
                      className="w-12 h-12 rounded-full object-cover"
                    />
                    <div>
                      <h3 className="font-bold text-[#1F2937]">Mark Thompson</h3>
                      <p className="text-[#6B7280]">Guildford</p>
                    </div>
                  </div>
                  <p className="text-[#4B5563]">
                    "I knew that I wasn't on the cheapest plans but didn't want to dig into the topic. KOSI told me what to do without having to look at it myself."
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="w-full bg-[#059669] py-20">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-4xl font-bold text-white mb-6">
            Ready to Optimise Your Energy Usage?
          </h2>
          <p className="text-xl text-[#D1FAE5] mb-8">
            Join thousands of satisfied users who are saving money whilst helping the environment.
          </p>
          <Button 
            className="h-[60px] px-8 text-lg bg-white text-[#059669] hover:bg-white/90"
            asChild
          >
            <Link to="/auth">Start Your Free Assessment Now</Link>
          </Button>
        </div>
      </section>

      <MartinLewisQuote />

      <Footer />
    </div>
  );
};

export default Index;
